import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'imageUrl',
  standalone: false,
})
export class ImageUrlPipe implements PipeTransform {
  transform(image: any): string {
    return typeof image === 'string' ? image : image?.['secureUrl'] || image?.['url']
  }
}
